import { styled as t, Box as c, useMediaQuery as L } from "@mui/material";
import N from "../../assets/background-login-popup.png.js";
import B from "../../assets/image-bind-email-mobile.jpg.js";
import I from "../../assets/logo.png.js";
import { LOGIN_SLIDE_STATE as d } from "../../constants/login.js";
import O from "./LoginGameClientSection.js";
import y from "./RoninLoginSection.js";
import R from "./RootLoginSection.js";
import $ from "./SelectWalletSection.js";
import P from "./SignupSection.js";
import v from "../../../temp-lib/components/share/next/Image.js";
import A from "../../../temp-lib/components/share/popup/InfoPopup.js";
import { ChainAddressType as u } from "../../../temp-lib/constants/chain.js";
import { INFO_POPUP_TYPE as M } from "../../../temp-lib/constants/popup.js";
import { WalletType as f } from "../../../temp-lib/constants/web3.js";
import { useAccountContext as w } from "../../../temp-lib/contexts/account/AccountContext.js";
import G from "../../../temp-lib/styles/theme.js";
import { isIosOrAndroid as T } from "../../../temp-lib/util/browser/index.js";
import _ from "../../../ui-lib/components/BackButton.js";
import { MobileWalletSnackBarMode as E } from "../../../wallet-lib/constants/index.js";
import { useRoninWalletSnackBarContext as W } from "../../../wallet-lib/contexts/RoninWalletSnackbarContext.js";
import * as g from "ramda";
import { useCallback as r, useRef as z, useState as H } from "react";
import { EffectFade as j, Controller as F } from "swiper/modules";
import { Swiper as V, SwiperSlide as s } from "swiper/react";
import { jsx as e, jsxs as p } from "react/jsx-runtime";
const X = t(A)`
  max-width: 95vw;

  ${(o) => o.theme.breakpoints.up("res1024")} {
    border-bottom-right-radius: 40px;
    border-top-left-radius: 40px;
    max-height: 95%;
    overflow: hidden;
  }

  ${(o) => o.theme.breakpoints.down("res1024")} {
    background-color: #1c1f25;
    max-height: 80%;
    height: 100%;
  }

  .Custom-Content {
    display: flex;
    height: auto;
    max-height: 100%;
    overflow-y: auto;
    position: relative;

    ${(o) => o.theme.breakpoints.down("res1024")} {
      flex-direction: column;
    }
  }

  .Custom-Header {
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
  }
`, D = t(_)`
  position: absolute;
  top: 10px;
  left: 20px;
`, K = t(c)`
  display: flex;
  /* z-index: 7; */
  ${(o) => o.theme.breakpoints.up("res1024")} {
    height: min(790px, calc(100vh - 40px));
    width: 1120px;
    background-color: #262829;
    box-shadow: 0px 8px 32.4316px rgba(0, 0, 0, 0.65);
    /* position: fixed; */
  }
  ${(o) => o.theme.breakpoints.down("res1024")} {
    flex-direction: column;
    width: 100%;
    top: 50px;
    background-color: #1c1f25;
  }
`, Q = t(V)`
  & .swiper-wrapper,
  .swiper-slide {
    ${(o) => o.theme.breakpoints.up("res1024")} {
      width: 560px;
      height: min(790px, calc(100vh - 40px)) !important;
    }
    ${(o) => o.theme.breakpoints.down("res1024")} {
      width: 100%;
    }
  }

  ${(o) => o.theme.breakpoints.down("res1024")} {
    width: 100%;
  }
`, b = t(c)`
  position: relative;

  ${(o) => o.theme.breakpoints.up("res1024")} {
    background-image: url(${`"${N}"`});
    background-size: 100%;
    background-repeat: no-repeat;
    background-color: #1c242c;
    height: 100%;
    flex: 1;
    max-width: 560px;
  }

  ${(o) => o.theme.breakpoints.down("res1024")} {
    background-image: url(${`"${B}"`});
    background-size: 100%;
    width: 100%;
    aspect-ratio: 2;
    transform: scaleX(-1);
    background-repeat: no-repeat;
    background-size: 100%;
    margin-bottom: -60px;
  }
`, U = t(c)`
  position: absolute;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    #1c1f25 80%,
    #1c1f25 100%
  );
`, Y = t(O)`
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 40px;
`, q = t(v)`
  position: absolute;
  aspect-ratio: 4.15;
  height: 25%;
  bottom: 0;
  top: 0;
  right: 10%;
  margin: auto;
  transform: scaleX(-1);
`, J = t(c)`
  position: relative;
  flex: 1;
  height: 100%;
`, Z = () => {
  const o = z(), [l, m] = H(!1), {
    loginByWallet: i
  } = w(), {
    openSnackBar: a
  } = W(), x = L(G.breakpoints.down("res1024")), k = r(() => {
    g.isNotNil(o.current) && o.current.slideTo(d.EMAIL_LOGIN);
  }, []), S = r((n) => {
    o.current = n;
  }, []), C = r((n) => {
    m(n.activeIndex !== d.EMAIL_LOGIN);
  }, []), h = r(async () => {
    if (T()) {
      window.ronin ? await i(f.Ronin, u.RONIN) : (a(E.Connect), await i(f.RoninMobile, u.RONIN));
      return;
    }
    g.isNotNil(o.current) && o.current.slideTo(d.RONIN_WALLET_LOGIN);
  }, [i, a]);
  return /* @__PURE__ */ p(K, {
    children: [x ? /* @__PURE__ */ p(b, {
      children: [/* @__PURE__ */ e(U, {}), /* @__PURE__ */ e(q, {
        src: I
      })]
    }) : /* @__PURE__ */ e(b, {
      children: /* @__PURE__ */ e(Y, {})
    }), /* @__PURE__ */ p(J, {
      children: [/* @__PURE__ */ p(Q, {
        allowTouchMove: !1,
        autoHeight: !0,
        direction: "horizontal",
        modules: [j, F],
        slidesPerView: 1,
        spaceBetween: 0,
        onSwiper: S,
        onActiveIndexChange: C,
        children: [/* @__PURE__ */ e(s, {
          children: /* @__PURE__ */ e(R, {
            onRoninLogin: h
          })
        }), /* @__PURE__ */ e(s, {
          children: /* @__PURE__ */ e($, {
            onRoninLoginClick: h
          })
        }), /* @__PURE__ */ e(s, {
          children: ({
            isActive: n
          }) => /* @__PURE__ */ e(y, {
            isActive: n
          })
        }), /* @__PURE__ */ e(s, {
          children: /* @__PURE__ */ e(P, {})
        })]
      }), l && /* @__PURE__ */ e(D, {
        onClick: k
      })]
    })]
  });
}, Io = (o) => {
  const {
    className: l
  } = o, {
    showLoginPopup: m,
    setShowLoginPopup: i
  } = w(), a = r(() => {
    i(!1);
  }, [i]);
  return /* @__PURE__ */ e(X, {
    className: l,
    keepMounted: !1,
    type: M.BLACK,
    open: m,
    onClose: a,
    children: /* @__PURE__ */ e(Z, {})
  });
};
export {
  Io as default
};
//# sourceMappingURL=LoginView.js.map
